import { IntroVideoType } from '~/models/intro-video/model';
export const videoUrl = (introVideo)=>introVideo.type === IntroVideoType.VideoLink ? introVideo.videoLink.url : null;
